import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-C78HRAnj.js';

const statusCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;box-sizing:border-box;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;font-weight:600;gap:.5rem;letter-spacing:-.0004em;line-height:normal;line-height:1.25rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .dot{border-radius:624.9375rem;height:.5rem;width:.5rem}:host .filled-icon{align-items:center;border-radius:624.9375rem;display:inline-flex;height:1rem;justify-content:center;margin-top:.125rem;min-width:1rem;width:1rem}:host([intent=error]){color:var(--jw-theme-error-surface-color)}:host([intent=error]) .dot{background-color:var(--jw-theme-error-surface-color)}:host([intent=error]) .filled-icon{background-color:var(--jw-theme-error-muted-message-bg-color)}:host([intent=error]) .filled-icon wui-icon{color:var(--jw-theme-error-muted-message-color)}:host([intent=warning]){color:var(--jw-theme-warning-surface-color)}:host([intent=warning]) .dot{background-color:var(--jw-theme-warning-surface-color)}:host([intent=warning]) .filled-icon{background-color:var(--jw-theme-warning-muted-message-bg-color)}:host([intent=warning]) .filled-icon wui-icon{color:var(--jw-theme-warning-muted-message-color)}:host([intent=information]){color:var(--jw-theme-info-surface-color)}:host([intent=information]) .dot{background-color:var(--jw-theme-info-surface-color)}:host([intent=information]) .filled-icon{background-color:var(--jw-theme-info-muted-message-bg-color)}:host([intent=information]) .filled-icon wui-icon{color:var(--jw-theme-info-muted-message-color)}:host([intent=success]){color:var(--jw-theme-success-surface-color)}:host([intent=success]) .dot{background-color:var(--jw-theme-success-surface-color)}:host([intent=success]) .filled-icon{background-color:var(--jw-theme-success-muted-message-bg-color)}:host([intent=success]) .filled-icon wui-icon{color:var(--jw-theme-success-muted-message-color)}:host([intent=inactive]){color:var(--jw-theme-surface-text-description-color)}:host([intent=inactive]) .dot{background-color:var(--jw-theme-surface-text-description-color)}:host([intent=inactive]) .filled-icon{background-color:var(--jw-theme-neutral-muted-message-bg-color)}:host([intent=inactive]) .filled-icon wui-icon{color:var(--jw-theme-neutral-muted-message-color)}:host([type=guide]){align-items:flex-start}:host([type=guide]) span{color:var(--jw-theme-surface-text-default-color)}:host([type=custom-icon]),:host([type=guide]),:host([type=icon]){gap:.25rem}";

const WuiStatus = /*@__PURE__*/ proxyCustomElement(class WuiStatus extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Status icon type: with dot, with icon, with no icon (label only), guide
         */
        this.type = 'dot';
        /**
         * Status message
         */
        this.text = '';
        this.getIconName = (intent, isIconFilled = false) => {
            if (this.type === 'custom-icon' && this.iconName)
                return this.iconName;
            switch (intent) {
                case 'error':
                    return isIconFilled ? 'x' : 'alert-circle';
                case 'warning':
                    return isIconFilled ? 'question-mark' : 'alert-triangle';
                case 'information':
                    return isIconFilled ? 'arrow-down' : 'info-circle';
                case 'success':
                    return isIconFilled ? 'check' : 'circle-check';
                case 'inactive':
                    return 'ban';
            }
        };
    }
    render() {
        return (h(Host, { key: '13086ce24c5adc0b4a039a6744ec2cf511af2a07' }, this.type === 'dot' && h("div", { key: '66953bb27ceef81154b4b4aef5da73cf416ccfa6', class: "dot" }), (this.type === 'icon' || this.type === 'custom-icon') && (h("wui-icon", { key: 'cdef096a9f69195bde47b1cd4f42f351235638bb', size: "md", name: this.getIconName(this.intent) })), this.type === 'guide' && (h("div", { key: 'e7f8e008da7ad9f72171675703b8c6a8acecd93d', class: "filled-icon" }, h("wui-icon", { key: '824675e37f0e541140555eb9a0f39a92a8fcc4ec', size: "sm", name: this.getIconName(this.intent, true) }))), h("span", { key: 'b35ca710b114bc86aa4786e91dd356015485f2b1' }, this.text)));
    }
    static get style() { return statusCss; }
}, [257, "wui-status", {
        "intent": [513],
        "type": [1],
        "iconName": [513, "icon-name"],
        "text": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-status", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-status":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiStatus);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiStatus as W, defineCustomElement as d };
